module.exports = __webpack_public_path__ + "img/template4.5cd477d4.svg";